<!-- 不良申诉 二级页面 form 组件 -->
<template>
  <h-inspection-page :title="h_i18n('4cbd267973099462346173a3cc9396b5')+data.title" @inspection-update="inspectionUpdate" class="componentAppeal">
    <form-header :title="h_i18n('4cbd267973099462346173a3cc9396b5')+data.title" class="top_wrap_style" title-width="4">
      <template #title>
        <h-p align="left" :title="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')">{{ time(new Date()) }}</h-p>
        <h-p align="left" :title="h_i18n('4850ea222f13bd23bec1cdace19cb633')">{{ getData.appealId }}</h-p>
      </template>
      <template #body>
        <tr>
          <report-td :title="h_i18n('93088b3ee041cfcf2c25b1b3ddd5fef1')" colspan="4:8">
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tipFlag.badTypename"
              :content="h_i18n('26cb711afb8ff42c471f0dddbfaea6ec')">
              <div></div>
            </el-tooltip>
            <el-select v-model="postData.badTypename" clearable filterable :disabled="getData.eightdId || getData.rectifyId || getData.sendGoodsNo || getData.rejectsId"
              @change="changeNull(postData.badTypename, 'badTypename')" v-if="kindType == 'sqmAdd'">
                <el-option :label="h_i18n('192da253760c41cbab573083fc3c7d5d')" value="现场不良"></el-option>
                <el-option :label="h_i18n('1d3da79822f03f22f73ca43974d8a15a')" value="入厂不合格"></el-option>
                <el-option :label="h_i18n('f5a6a3a1e5bcddf045542b92ff04a564')" value="实验不合格"></el-option>
                <el-option :label="h_i18n('0addf9d81daedc6979addd92d00e46c1')" value="停检单"></el-option>
                <el-option :label="h_i18n('f37dba0758deb9ad0bead5f15776dd35')" value="纠偏单"></el-option>
                <el-option :label="h_i18n('34d22f83ae2b434ad919397ed951b25e')" value="8D整改单"></el-option>
                <el-option :label="h_i18n('42BDBB277A143FAB6DA9941628785915')" value="差异化供应商市场不良品"></el-option>
                <el-option :label="h_i18n('7CA6AFBB33477479BD9B344FA1B50A90')" value="破坏性实验补料"></el-option>
            </el-select>
            <el-input disabled v-model="postData.badTypename" v-else></el-input>
          </report-td>
          <report-td :title="h_i18n('96ad1b86c31e8f1965a3fdafae75975d')" colspan="4:8">
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tipFlag.badId"
              :content="h_i18n('e31486583190b17ea157c82faabb585a')">
              <div></div>
            </el-tooltip>
            <el-select v-model="postData.badId" clearable filterable :disabled="getData.eightdId || getData.rectifyId || getData.sendGoodsNo || getData.rejectsId"
              :placeholder="h_i18n('e6e4e28bbc17cb5986272bc77cdadd7e')" v-if="kindType == 'sqmAdd'"
              @change="changeNull(postData.badId, 'badId')">
                <el-option v-for="(item,index) in data.badIdList" :key="index" :label="item.rejectsId" :value="item.rejectsId"></el-option>
            </el-select>
            <div disabled @click="openOfNo(postData.badId)" v-else
            style="cursor:pointer;color:#2164f5;border: 1px solid #E4E7ED;border-radius: 4px;height:38px;line-height: 38px;background-color: #F5F7FA;padding-left: 15px;">{{ postData.badId }}</div>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" colspan="4:8">
            <el-input disabled :placeholder="h_i18n('a64fcc8c79de269f19bd5746fe111b38')" v-model="postData.mtlNo"></el-input>
          </report-td>
          <report-td :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" colspan="4:8">
            <el-input disabled :placeholder="h_i18n('a64fcc8c79de269f19bd5746fe111b38')" v-model="postData.mtlName"></el-input>
          </report-td>
        </tr>
        <tr>
          <!-- 供应商代码 -->
          <report-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" colspan="4:8">
            <el-input disabled :placeholder="h_i18n('a64fcc8c79de269f19bd5746fe111b38')" v-model="postData.supplyCode"></el-input>
          </report-td>
          <!-- 供应商名称 -->
          <report-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" colspan="4:8">
            <el-input disabled :placeholder="h_i18n('a64fcc8c79de269f19bd5746fe111b38')" v-model="postData.supplyName"></el-input>
          </report-td>
        </tr>
        <tr>
          <!-- 数量 -->
          <report-td :title="h_i18n('0bf60b32f9db93b87e08763b1c815469')" colspan="4:8">
            <el-input disabled v-model="postData.number"></el-input>
          </report-td>
          <!-- 工厂小微 -->
          <report-td :title="h_i18n('03490f3868798323211aa633194df2c1')" colspan="4:8">
            <el-input disabled :placeholder="h_i18n('a64fcc8c79de269f19bd5746fe111b38')" v-model="postData.sybName"></el-input>
          </report-td>
        </tr>
        <tr>
          <!-- 不良描述 -->
          <report-td :title="h_i18n('97cadad0bbee7252a5db6351a8d8d5ca')" colspan="4:20">
            <el-input disabled :placeholder="h_i18n('a64fcc8c79de269f19bd5746fe111b38')" v-model="postData.badDescribe"></el-input>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('e998e6528503388a3f348a8fc0ec072b')" colspan="4:8">
            <el-input v-model="postData.inputName" disabled></el-input>
          </report-td>
          <!-- 申诉时间 -->
          <report-td :title="h_i18n('8f22e1b0d934d2cfc729a71d5f0c74ff')" colspan="4:8">
            <el-input v-model="postData.inputDate" disabled></el-input>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('f3e5b25f91e7707e5da2fe1668a680f7')" colspan="4:20">
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tipFlag.appealContent"
              :content="h_i18n('b79c78d963694a6eea59f441ba8b452a')">
              <div></div>
            </el-tooltip>
            <el-input :rows="4" show-word-limit maxlength="200" type="textarea" class="td-height-style"
            v-model="postData.appealContent" :disabled="kindType != 'sqmAdd'"></el-input>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" colspan="4:20">
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tipFlag.fileUuid"
              :content="h_i18n('506ca53a3365fd9217ba87b4347a1636')">
              <div></div>
            </el-tooltip>
            <hc-file-upload download delete v-model="data.fileTemp" accept="all" size="30"
              :info="h_i18n('2c15033baf4a3116291e231f7e3909a0')" @error="errorFile"
              @delete="deleteFun" @download="download" @change="fileChange" v-if="kindType == 'sqmAdd'">
            </hc-file-upload>
            <h-file v-else-if="postData.fileUuid && postData.fileName" :name="postData.fileName" :delete-type="false" :url="postData.fileUuid" @delete="deleteFun"
              :autoOpen='false' @open="openFile(postData.fileUuid, postData.fileName)"></h-file>
          </report-td>


        </tr>
        <tr v-if="kindType == 'sqmAdd'">
          <report-td :title="h_i18n('1bbbb204023e59eba03319c7c5848fd1')" colspan="4:20">
            <span style="display:block;color:red;">{{ h_i18n('99f6ff342360e244ce7351c3bba57f44') }}</span>
          </report-td>
        </tr>
        <template v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'">

          <h-tr>{{ h_i18n('ec3141f1fe7cc930186acaab1868a73e') }}</h-tr>
          <tr class="tabletitle-ll">
            <td colspan="5">{{ h_i18n('80500fc9d5eb7729d2f489bc92e92e3e') }}</td>
            <td colspan="5">{{ h_i18n('60d0458ac6ebef0fff1331af196b3c82') }}</td>
            <td colspan="5">{{ h_i18n('19fcb9eb2594059036dfede5f4ec53e8') }}</td>
            <td colspan="5">{{ h_i18n('3fea7ca76cdece641436d7ab0d02ab1b') }}</td>
            <td colspan="4">{{ h_i18n('a6396f13c260444d561afaa9407467be') }}</td>
          </tr>
          <tr class="tablebody-ll" v-show="getData.badTypename == h_i18n('192da253760c41cbab573083fc3c7d5d')">
              <td colspan="5">{{ h_i18n('82da895cd022775edf8ccb40b8f79e8f') }}</td>
              <td colspan="5" v-if="getData.appealNjname">*</td>
              <td colspan="5" v-else></td>
              <td colspan="5">
                <span v-if="getData.appealNjdate">
                  {{ time(getData.appealNjdate,6) }}
                </span>
                <span v-else>-</span>
              </td>
              <td colspan="5">
                <span v-if="getData.appealNjresult == 'P'">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</span>
                <span v-else-if="getData.appealNjresult == 'F'">{{ h_i18n('dec0624c91cfca219e1b41ce89c19780') }}</span>
                <span v-else>{{ h_i18n('2839c8c87d814d9a1e592965fae86b54') }}</span>
              </td>
              <td colspan="4">
                <span v-if="getData.appealNjmark">
                  {{ getData.appealNjmark }}
                </span>
                <span v-else>-</span>
              </td>
            </tr>
            <tr class="tablebody-ll">
              <td colspan="5">{{ h_i18n('907990ffe2aa0d62fcd98926415253a4') }}</td>
              <td colspan="5" v-if="getData.appealBzname">*</td>
              <td colspan="5" v-else></td>
              <td colspan="5">
                <span v-if="getData.appealBzdate">
                  {{ time(getData.appealBzdate,6) }}
                </span>
                <span v-else>-</span>
              </td>
              <td colspan="5">
                <span v-if="getData.appealBzresult == 'P'">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</span>
                <span v-else-if="getData.appealBzresult == 'F'">{{ h_i18n('dec0624c91cfca219e1b41ce89c19780') }}</span>
                <span v-else>{{ h_i18n('2839c8c87d814d9a1e592965fae86b54') }}</span>
              </td>
              <td colspan="4">
                <span v-if="getData.appealBzmark">
                  {{ getData.appealBzmark }}
                </span>
                <span v-else>-</span>
              </td>
            </tr>
        </template>

        
      </template>
      <div style="padding:20px 0">
        <h-button-group align="center">
          <h-button type="primary" size="small" :loading="subLoading" @click="submit" v-if="kindType == 'sqmAdd'">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
          <h-button type="default" size="small" @click="back">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </div>
    </form-header>
    
    

  </h-inspection-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import {reactive,getCurrentInstance,onMounted, onBeforeMount, nextTick, onUpdated, ref, defineEmit, computed} from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  const { proxy, ctx } = getCurrentInstance();
  const route = useRoute();
  const emit = defineEmit(
    ['submitBtn','backBtn']
  )
  const tipFlag = reactive({
    badTypename:false,
    badId:false,
    appealContent:false,
    fileUuid:false,
    
    mtlNo:false,
    mtlName:false,
  })
  const props = defineProps({
    kindType: {
      type: String,
      default: ''
    },
    getData: {
      type:Object,
      default: {}
    },
    subLoading: {
      type:Boolean,
      default:false
    }
  })
  const data = reactive({
    title:'',
    fileTemp:{},
    badIdList:[]
  })
  const postData = reactive({
    mtlNo:'',
  })

  /**
 * 传高度
 */
const changeMethod = () => {
  proxy.postThisPageHeight();
};
// 打开不良单
const openOfNo = (badId) => {
  console.log(postData.badTypename,badId)
  let routerName = ''
  let toSqmUrl = 'https://sqmnew.haier.net/sqmnewfront/#'
  if(process.env.NODE_ENV == "development"){
    toSqmUrl = 'https://pre-hmqm-server.haier.net/mkhl/#'
  }
  if (postData.badTypename == "现场不良") {
    proxy.$router.push({
    path: '/inFactoryRejectsDetailPage',
    query: {
      mtlNo: postData.mtlNo,
      dataFrom: 'sqm',
      rejectsId: postData.badId,
    }
  });
  return
    // routerName = '/newMain/bldetail?rejectsId='+badId
  } else if (postData.badTypename == "入厂不合格") {
    if(props.getData.type){
      proxy.$router.push({
        path: '/intoFactoryUnqualifiedDetailPage',
        query: {
          mtlNo: postData.mtlNo,
          dataFrom: 'sqm',
          type: props.getData.type,
          sendGoodsNo: postData.badId,
          checkTime: props.getData.checkTime,
          source: props.getData.source,
          uuidFail: props.getData.uuidFail,
          goodsSort: props.getData.goodsSort,
        },
      });
      // let thisData = props.getData
      // routerName = `newMain/blrcdetailvmi?sendGoodsNo=${badId}&data=${thisData}`
    }else{
      let sourceTemp = 'PC'
      proxy.startLoading('...')
      proxy.$http({
        method: 'get',
        url: `/base/batchPlanTestConclusionFail/batchRecordDetailNew?sendGoodsNos=${postData.badId}&mtlNo=${postData.mtlNo}
        &checkTime=${postData.checkTime}&uuidFail=${postData.uuid}&source=${sourceTemp}&goodsSorts=${postData.goodsSort || '0'}`,
      }).then(res=>{
        console.log(res)
        if(res.data.batchRecordTable){
          sourceTemp = 'PC'
        }else{
          sourceTemp = 'APP'
        }
      }).catch(err=>{

      }).finally(()=>{
        proxy.$router.push({
          path: '/intoFactoryUnqualifiedDetailPage',
          query: {
            mtlNo: postData.mtlNo,
            dataFrom: 'sqm',
            sendGoodsNo: postData.badId,
            checkTime: props.getData.checkTime,
            source: sourceTemp,
            uuidFail: props.getData.uuid,
            goodsSort: props.getData.goodsSort || '0',
          }
        })
        proxy.closeLoading()
      })
      //  routerName = `/newMain/blrcdetail?sendGoodsNo=${badId}&mtlNo=${props.getData.mtlNo}&goodsSort=${props.getData.goodsSort}&uuidFail&checkTime=${props.getData.checkTime}`
    }
    return
  } else if (postData.badTypename == "实验不合格") {
    // routerName = 'newMain/blsydetail?testNo='+badId
    proxy.$router.push({
        name: "sqmExperimentRecordDetail",
        query: {
          testNo: postData.badId,
        }
      })
    return
  } else if (postData.badTypename == "停检单") {
    // let thisData = {supplyCode:props.getData.supplyCode}
    //  routerName = `newMain/bltjddetail?stopCheckId=${badId}&userData=${thisData}`
    proxy.$router.push({
      name:'RejectsStopDetail',
      query:{
        supplyCode:props.getData.supplyCode,
        stopCheckId:badId,
        sourceId:props.getData.sourceId,
        dataFrom:'sqm',
      }
    })
    return
  } else if(postData.badTypename == "纠偏单"){
    proxy.$router.push({
      name:'RectifyReportDetail',
      query:{
        supplyCode:props.getData.supplyCode,
        rectifyId:badId,
        sourceId:props.getData.sourceId,
        dataFrom:'sqm',
      }
    })
    return
  } else if(postData.badTypename == "8D整改单"){
    proxy.$router.push({
      name:'Rejects8dDetail',
      query:{
        supplyCode:props.getData.supplyCode,
        eightdId:badId,
        sourceId:props.getData.sourceId,
        dataFrom:'sqm',
      }
    })
    return
  } else if(postData.badTypename == "差异化供应商市场不良品"){
    let SQM_LATEST = ''
    if(process.env.NODE_ENV === 'development'){
      // SQM_LATEST = 'http://localhost:9551/sqm/#'
      SQM_LATEST = 'https://pre-sqm-front.haier.net/sqm/#'
    }else if(process.env.NODE_ENV === 'production'){
      SQM_LATEST = 'https://sqmnew.haier.net/sqm/#'
    }else{
      SQM_LATEST = 'https://pre-sqm-front.haier.net/sqm/#'
    }
    let DOM = window.top.document.querySelector("#iframeSelf")
    DOM.setAttribute("src", SQM_LATEST+'/Content/DifPreClmMktDefDetail?problemNo='+badId)
    // window.open(SQM_LATEST+'/Content/DifPreClmMktDef')
  } else if(postData.badTypename == "破坏性实验补料"){
    let SQM_LATEST = ''
    if(process.env.NODE_ENV === 'development'){
      // SQM_LATEST = 'http://localhost:9551/sqm/#'
      SQM_LATEST = 'https://pre-sqm-front.haier.net/sqm/#'
    }else if(process.env.NODE_ENV === 'production'){
      SQM_LATEST = 'https://sqmnew.haier.net/sqm/#'
    }else{
      SQM_LATEST = 'https://pre-sqm-front.haier.net/sqm/#'
    }
    let DOM = window.top.document.querySelector("#iframeSelf")
    DOM.setAttribute("src", SQM_LATEST+'/Content/DEInspectionPlanDetail?id='+badId)
    // window.open(SQM_LATEST+'/Content/DifPreClmMktDef')
  }
  // window.open(toSqmUrl+routerName ,"_blank")
}
const badIdListSearch = () => {
  let rejectsIdnull = ""
  let searchBLlist = ""
  if (postData.badTypename == "现场不良") {
    searchBLlist = `/base/RefusalAppeal/supperBLJList?rejectsId=${rejectsIdnull}&supplyCode=${postData.supplyCode}`
  } else if (postData.badTypename == "入厂不合格") {
    searchBLlist = `/base/RefusalAppeal/batchfail?sendGoodsNo=${rejectsIdnull}&batchFailId=${rejectsIdnull}&uuid=${rejectsIdnull}&supplyCode=${postData.supplyCode}`
  } else if (postData.badTypename == "实验不合格") {
    searchBLlist = `/base/RefusalAppeal/testtask?TestNo=${rejectsIdnull}&supplyCode=${postData.supplyCode}`
  } else if (postData.badTypename == "停检单") {
    searchBLlist = `/base/RefusalAppeal/rejectsStop?stopCheckId=${rejectsIdnull}&supplyCode=${postData.supplyCode}`
  } else if(postData.badTypename == "纠偏单"){
    searchBLlist = `/base/RefusalAppeal/rejectsRectify?rectifyId=${rejectsIdnull}&supplyCode=${postData.supplyCode}`
  } else if(postData.badTypename == "8D整改单"){
    searchBLlist = `/base/RefusalAppeal/rejects8d?eightdId=${rejectsIdnull}&supplyCode=${postData.supplyCode}`
  } else if(postData.badTypename == "差异化供应商市场不良品"){
    searchBLlist = `/base/RefusalAppeal/problemConfirm?problemNo=${rejectsIdnull}&supplyCode=${postData.supplyCode}`
  } else if(postData.badTypename == "破坏性实验补料"){
    searchBLlist = `/base/RefusalAppeal/destructiveFail?destructiveTestNo=${rejectsIdnull}&supplyCode=${postData.supplyCode}`
  }
  data.badIdList = [];
  // data.fetching = true
  proxy.$http({
    method: "post",
    url: searchBLlist,
  }).then((res) => {
    if (res.data.data.length > 0) {
      data.badIdList = res.data.data;
      let newArrList = [];
      if (postData.badTypename == "现场不良") {
          res.data.data.map((item) => {
            newArrList.push(
              Object.assign(
                item,
                { value: item.rejectsId },
                { badId: item.rejectsId }
              )
            );
          });
          data.badIdList = newArrList;
      } else if(postData.badTypename == "入厂不合格"){
          res.data.data.map((item) => {
            newArrList.push(
              Object.assign(
                item,
                { rejectsId: item.sendGoodsNo }
              )
            );
          });
          data.badIdList = newArrList;
      } else if(postData.badTypename == "实验不合格"){

          res.data.data.map((item) => {
            newArrList.push(
              Object.assign(
                item,
                { rejectsId: item.testNo })
            );
          });
          data.badIdList = newArrList;
      } else if(postData.badTypename == "停检单"){
        
        res.data.data.map((item) => {
          newArrList.push(
            Object.assign(
              item,
              { rejectsId: item.stopCheckId })
          );
        });
        data.badIdList = newArrList;
      } else if(postData.badTypename == "纠偏单"){
        
        res.data.data.map((item) => {
          newArrList.push(
            Object.assign(
              item,
              { rejectsId: item.rectifyId })
          );
        });
        data.badIdList = newArrList;
      } else if(postData.badTypename == "8D整改单"){
        
        res.data.data.map((item) => {
          newArrList.push(
            Object.assign(
              item,
              { rejectsId: item.eightdId, number:item.num })
          );
        });
        data.badIdList = newArrList;
      } else if(postData.badTypename == "差异化供应商市场不良品"){
        
        res.data.data.map((item) => {
          newArrList.push(
            Object.assign(
              item,
              { badId: item.problemNo, number:item.badCount, badDescribe: item.failureWay,rejectsId: item.problemNo })
          );
        });
        data.badIdList = newArrList;
      } else if(postData.badTypename == "破坏性实验补料"){
        res.data.data.map((item) => {
          newArrList.push(
            Object.assign(
              item,
              { badId: item.destructiveTestNo, number:item.orderNum,badDescribe:item.flawMark,rejectsId: item.destructiveTestNo})
          );
        });
        data.badIdList = newArrList;
      } 
    } else {
      data.badIdList = [];
    }
  }).catch(err=>{
    proxy.warning(err)
  }).finally(()=>{

  })
}
const badIdSelect = (val) => {
  if (postData.badTypename =="现场不良") {
    proxy.$http({
      method: "get",
      url: `/base/RefusalAppeal/selectSS?badid=${postData.badId}`,
    }).then((res) => {
      if(res.data.data > 0) {
        proxy.warning(h_i18n('f5a67399a03a30de156bc9ffcd9ef3ff'))
      } else {
        // Loading.error("此单号不存在，请重新录入！");
        data.badIdList.forEach((el) => {
          if (el.rejectsId == val) {
            for (const key in el) {
              postData[key] = el[key]
            }
            // 特别参数处理
            postData.badDescribe = el.flawMark
          }
        });
      }
    });
  } else if(postData.badTypename == "入厂不合格" ){
    // 这个地方可能会改
    data.badIdList.forEach((el) => {
      if (el.rejectsId == val) {
        for (const key in el) {
          postData[key] = el[key]
        }
        // 特别参数处理
        postData.badId = el.sendGoodsNo;
        postData.badDescribe = el.flawMark;
        postData.number = el.patternAmount
      }
    });
  } else if(postData.badTypename == "实验不合格" ){
    // 这个地方可能会改
    data.badIdList.forEach((el) => {
      if (el.rejectsId == val) {
        for (const key in el) {
          postData[key] = el[key]
        }
        // 特别参数处理
        postData.badId = el.testNo;
        postData.badDescribe = el.flawMark;
        postData.sybName = el.consignDepart;
        postData.mtlName = el.patternName;
        postData.mtlNo = el.patternNo;
        postData.number = el.patternAmount
      }
    });
  } else if(postData.badTypename == "停检单" ){
    // 这个地方可能会改
    data.badIdList.forEach((el) => {
      if (el.rejectsId == val) {
        for (const key in el) {
          postData[key] = el[key]
        }
        // 特别参数处理
        postData.badId = el.stopCheckId;
        postData.badDescribe = el.stopReason;
        postData.number = el.tjnumber
      }
    });
  } else if(postData.badTypename == "纠偏单" ){
    // 这个地方可能会改
    data.badIdList.forEach((el) => {
      if (el.rejectsId == val) {
        for (const key in el) {
          postData[key] = el[key]
        }
        // 特别参数处理
        postData.badId = el.rectifyId;
        postData.badDescribe = el.badAppearance;
        postData.number = el.number
      }
    });
  } else if(postData.badTypename == "8D整改单" ){
    // 这个地方可能会改
    data.badIdList.forEach((el) => {
      if (el.rejectsId == val) {
        for (const key in el) {
          postData[key] = el[key]
        }
        // 特别参数处理
        postData.badId = el.eightdId;
        postData.badDescribe = el.remark;
        postData.number = el.num
      }
    });
  } else if(postData.badTypename === "差异化供应商市场不良品" ){
    data.badIdList.forEach((el) => {
      if (el.rejectsId == val) {
        for (const key in el) {
          postData[key] = el[key]
        }
        // 特别参数处理
        postData.badId = el.problemNo;
        postData.badDescribe = el.failureWay;
        postData.number = el.badCount
      }
    })
  } else if(postData.badTypename === "破坏性实验补料" ){
    data.badIdList.forEach((el) => {
      if (el.rejectsId == val) {
        for (const key in el) {
          postData[key] = el[key]
        }
        // 特别参数处理
        postData.badId = el.destructiveTestNo;
        postData.badDescribe = el.flawMark;
        postData.number = el.orderNum
      }
    })
  }
  inputDateFun()
}
const inspectionUpdate = () => {
  proxy.postThisPageHeight();
}

  const submit = () => {
    if(!postData.supplyCode || !postData.supplyName){
      proxy.warning(h_i18n('d26e7275f9cd553afc85b43d5cc99f45'))
      return
    }
  if (!postData.badTypename || postData.badTypename.length < 1) {
    tipFlag.badTypename = true
    setTimeout(() => {
      tipFlag.badTypename = false
    }, 2000);
    return
  }
  if (!postData.badId || postData.badId.length < 1) {
    tipFlag.badId = true
    setTimeout(() => {
      tipFlag.badId = false
    }, 2000);
    return
  }
  
  if (!postData.appealContent) {
    tipFlag.appealContent = true
    setTimeout(() => {
      tipFlag.appealContent = false
    }, 2000);
    return
  }
  if (!postData.fileUuid || !postData.fileName) {
    tipFlag.fileUuid = true
    setTimeout(() => {
      tipFlag.fileUuid = false
    }, 2000);
    return
  }
  proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('ea26fd0c8e461561f8aca37302a4befb'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),
      callback: (action) => {
        if(action == 'confirm'){
          emit('submitBtn',postData)
        }
      },
    }) 
  }
  const back = () => {
    if(props.kindType == 'sqmAdd'){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('fa8cddd1d9052320cf5dfdeecda0a284'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),
        callback: (action) => {
          if(action == 'confirm'){
            emit("backBtn")
          }
        },
      })    
    }else{
      emit("backBtn")
    }

  }

  // input为空时undefined
  const changeNull = (value, key) => {
    if (value === "") {
      postData[key] = ''
      badIdChange()
    }
    if(key == 'badTypename'){
      badTypenameChange()
      postData.badId = ''
      if(value === ""){
      }else{
        badIdListSearch()
      }
    }
    if(key == 'badId'){
      badIdSelect(value)
      if(value === ""){
        postData.badId = ''
        badIdChange()
      }
    }
  }

  // 不良类型切换清空数据
  const badTypenameChange = () =>{
    postData.badId = ''
    data.badIdList = []
    badIdChange()
  }

  // 不良单号切换清空数据
  const badIdChange = () =>{
    postData.mtlNo = ''
    postData.mtlName = ''
    postData.number = ''
    postData.sybName = ''
    postData.badDescribe = ''
    postData.appealContent = ''
    postData.fileName = ''
    postData.fileUuid = ''
    data.fileTemp.name = ''
    data.fileTemp.file = ''
  }


  /**
 * 错误提示
 */
 const errorFile = (str) => {
  proxy.warning({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: str})
}

// 支持老附件下载
const openFile = (uuid,name) => {
  proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
  let url = ''
  if(uuid.includes('http')){
    url = "/base/fileDownload/downloadFile?filePath="+uuid.split('https://sqm.haier.net/readFile/')[1]
  }else{
    url = '/base/fileDownload/downloadFile?filePath='+uuid
  }
  proxy.httpFile({
    method: "get",
    url: url,
    headers: {'content-type': 'application/json'},
  }, name)
}

/**
 * h-file-upload 上传文件
 */
const fileChange = (file,f) => {
  
    postData.fileName = file.name
    
    let formData = new FormData()
    formData.append('files', file.file)
    proxy.startLoading(h_i18n('92cd554eff7896f979917f3ae449b460'))
    proxy.$http({
      method: "POST",
      url: "/base/fileUpload/uploadToOssSaveUrl",
      data: formData
    }).then(res => {
      if (res.data.code === "0") {
        postData.fileUuid = res.data.data
      } else {
        proxy.error(h_i18n('3a845c4dd82bd5a445333dfcbabb4350'))
        data.fileTemp = null
      }
    }).catch(err=>{

    }).finally(()=>{
      proxy.closeLoading()
    })
}
/**
 * h-file-upload 下载
 */
const download = () =>{
  
    proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
    proxy.httpFile({
      method: "get",
      url: "/base/fileDownload/downloadFile?filePath="+postData.fileUuid.split('https://sqm.haier.net/readFile/')[1],
      headers: {'content-type': 'application/json'},
    }, postData.fileName)
}

/**
 * h-file-upload 删除
 */
const deleteFun = () =>{
    postData.fileUuid = ''
    postData.fileName = ''
    data.fileTemp = {}  
}
// 各个页面 申诉按钮 进入的 初始数据
const init = () => {
  console.log(postData)
  let url = ''
  if(postData.badTypename == '纠偏单'){
    url = `/base/RefusalAppeal/rejectsRectify?rectifyId=${postData.badId}&supplyCode=${postData.supplyCode}`
  }else if(postData.badTypename == '8D整改单'){
    url = `/base/RefusalAppeal/rejects8d?eightdId=${postData.badId}&supplyCode=${postData.supplyCode}`
  }else if(postData.badTypename == '入厂不合格'){
    url = `/base/RefusalAppeal/batchfail?sendGoodsNo=${postData.badId}&batchFailId=${postData.batchFailId}&uuid=${postData.uuid}&supplyCode=${postData.supplyCode}`
  }else if(postData.badTypename == "现场不良") {
    url = `/base/RefusalAppeal/supperBLJList?rejectsId=${postData.badId}&supplyCode=${postData.supplyCode}`
  }
  data.badIdList = [];
  // data.fetching = true
  proxy.$http({
    method: "post",
    url: url,
  }).then((res) => {
    if (res.data.data.length > 0) {
      data.badIdList = res.data.data;
      if(postData.badTypename == '8D整改单'){
        data.badIdList[0].rejectsId = res.data.data[0].eightdId
      }else if(postData.badTypename == '纠偏单') {
        data.badIdList[0].rejectsId =  res.data.data[0].rectifyId
      }else if(postData.badTypename == '入厂不合格'){
        data.badIdList[0].rejectsId =  res.data.data[0].sendGoodsNo
      }else if(postData.badTypename == '现场不良'){
        data.badIdList[0].rejectsId =  res.data.data[0].rejectsId
      }
      // data.badIdList[0].rejectsId = postData.badTypename == '8D整改单' ? res.data.data[0].eightdId : (postData.badTypename == '纠偏单' ? res.data.data[0].rectifyId : '') 
      badIdSelect(postData.badId)

    } else {
      data.badIdList = [];
    }
  }).catch(err=>{
    proxy.warning(err)
  }).finally(()=>{

  })
}

onBeforeMount(()=>{
  props.kindType == 'sqmAdd' && (data.title = h_i18n('d9ac9228e8564657bbe9ca5359f95806'))
  props.kindType == 'sqmDetail' && (data.title = h_i18n('f26225bde6a250894a04db4c53ea03d0'))
  props.kindType == 'hmqmDetail' && (data.title = h_i18n('f26225bde6a250894a04db4c53ea03d0'))
  postData.supplyCode = props.getData.supplyCode
  postData.supplyName = props.getData.supplyName
  postData.inputName = props.getData.trueName
  // if(props.kindType !== 'sqmDetail'){
  // postData.inputDate = proxy.time(new Date(),6)
  // }
})
// 时间处理
const inputDateFun = () => {
  if(props.kindType === 'sqmDetail' || props.kindType === 'hmqmDetail'){
    for (const key in props.getData) {
      postData[key] = props.getData[key]
      if(key == 'inputDate'){
        postData.inputDate = proxy.time(props.getData.inputDate,6)
      }
    }
  }else{
    postData.inputDate = proxy.time(new Date(),6)
  }
}
onMounted(()=>{
  inputDateFun()

  if(props.getData.eightdId){
    postData.badTypename = '8D整改单'
    postData.badId = props.getData.eightdId
    init()
  }else if(props.getData.rectifyId){
    postData.badTypename = '纠偏单'
    postData.badId = props.getData.rectifyId
    init()
  }else if(props.getData.sendGoodsNo){
    postData.badTypename = '入厂不合格'
    postData.badId = props.getData.sendGoodsNo
    postData.uuid = props.getData.uuid
    postData.batchFailId = props.getData.batchFailId
    init()
  }else if(props.getData.rejectsId){
    postData.badTypename = '现场不良'
    postData.badId = props.getData.rejectsId
    init()
  }
})
</script>

<style lang="scss">
.componentAppeal{
  .td-height-style{
    textarea{
      height: 100%;
    }
  }
  .tabletitle-ll {
  td {
    height:41px;
    font-size:14px;
    color:#666;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    text-align:center;
    background: #FAFAFA;
  }
}
.tablebody-ll {
  td {
    height:41px;
    font-size:14px;
    color:#666;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    text-align:center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &:hover {
      white-space: normal;
      word-break: break-all;
    }
  }
}
}
</style>